import {useEffect, useState} from "react";
import {WeeklyDish} from "../../Types/WeeklyDish";
import {addToBasket} from "../../Services/BasketService";

type Props = {
  dish: WeeklyDish;
  onSaved: () => void;
};

function EditWeeklyItemBody({dish, onSaved}: Props) {
  const [amount, setAmount] = useState(String(dish.dishAmount));

  useEffect(() => {
    setAmount(String(1));
  }, [dish]);
  
  const handleAdd = async () => {
    const parsedAmount = Number(amount);

    if (!Number.isInteger(parsedAmount) || parsedAmount < 1) {
      alert("Vul een geldig aantal in");
      return;
    }

    if (parsedAmount > dish.dishAmount) {
      alert(`Er zijn maar ${dish.dishAmount} stuks beschikbaar`);
      return;
    }
    
    try {
      addToBasket(parsedAmount, dish);
      onSaved();
    } catch (err) {
      console.error(err);
      alert("Toevoegen mislukt");
    }
  };
  
  return (
    <div className="popup-form">
      <h2 className="header-1">
        {dish.menuItem.name}
      </h2>

      <p className="popup-description">
        {dish.menuItem.description}
      </p>
      
      <div className="double-buttons">
        <div className="form-item form-item--no-margin">
          <h3 className="input-label">
            Aantal
          </h3>

          <input
            id="weekly-amount"
            type="number"
            min="1"
            max={dish.dishAmount}
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            className="input-field input-field--small"
          />
        </div>
        
        <button type="button" onClick={handleAdd} className="button">
          Voeg toe
        </button>
      </div>
    </div>
  );
}

export default EditWeeklyItemBody;